<template>
<div>
  <VCard>
    <VCardText>
      <v-row>
        <v-col cols="6" md="3">
          <v-autocomplete v-model="selectedCountry"
          :items="allCountrys"
          item-title="country"
          item-value="countryCode"
          prepend-inner-icon="tabler-search"
          label="請選擇國家"
          @update:model-value="selectCountryAction()"
          clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="6" md="3">
          <v-autocomplete v-model="selectedRegion"
          :items="allRegions" 
          no-data-text="尚無資料"
          item-title="region"
          item-value="regionCode"
          prepend-inner-icon="tabler-search"
          label="請選擇地區"
          :disabled="allRegions.length<1"
          clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end">
          <v-btn color="primary" variant="tonal" 
          prepend-icon="tabler-plus" @click="openDialog(dialogActionStatus[0].value)">
            新增
          </v-btn>
          <v-btn color="success" variant="tonal" 
          v-if="isICSC01User"
          prepend-icon="tabler-file-import" @click="triggerImport" class="ml-3">
            匯入
          </v-btn>
          <input type="file" ref="fileInput" style="display: none" accept=".xlsx, .xls" @change="handleImport" />
          <v-btn color="secondary" variant="tonal" 
          v-if="isICSC01User"
          prepend-icon="tabler-download" @click="downloadSample" class="ml-3">
            下載範本
          </v-btn>
          <v-btn color="warning" prepend-icon="tabler-edit" 
          variant="tonal" 
          @click="editBtn(dialogActionStatus[1].value)" class="ml-3"
          :disabled="tableSelected.length>1||tableSelected.length<1"
          >
            修改
          </v-btn>
          <v-btn color="error"
          v-if="isICSC01User"
          variant="tonal"  
          @click="deleteBtn"
          prepend-icon="tabler-trash" 
          class="ml-3" 
          :disabled="tableSelected.length<1">
            刪除
          </v-btn>
          <v-btn 
          :color="selectedItemsAreActive ? 'grey' : 'success'"
          variant="tonal"  
          @click="toggleStatusBtn"
          :prepend-icon="selectedItemsAreActive ? 'tabler-ban' : 'tabler-check'" 
          class="ml-3" 
          :disabled="tableSelected.length<1">
            {{ selectedItemsAreActive ? '停用' : '啟用' }}
          </v-btn>
        </v-col>
      </v-row>
    </VCardText>
    <VDataTableServer
      v-model:items-per-page="size"
      v-model:page="page"
      :items-length="totalItems"
      v-model="tableSelected"
      item-value="prikey"
      show-select
      :headers="headers" 
      :items="items" 
      class="text-no-wrap border-t-sm rounded-0"
      no-data-text="尚無資料"
      @update:options="fetchData"
    >
      <!-- return-object -->
      <!-- <template v-slot:item.checkbox="{ item }">
        <v-checkbox v-model="item.selected"></v-checkbox>
      </template> -->
      <template #item.dailyAllowance="{ item }">
        {{ formatAmount(item.dailyAllowance, '0') }}
      </template>
      <template #item.effectiveDate="{ item }">
        {{westernToRoc(item.effectiveDate,'-','/')}}
      </template>
      <template #item.expiryDate="{ item }">
        {{ item.expiryDate ? westernToRoc(item.expiryDate, '-', '/') : '' }}
      </template>
      <template #item.status="{ item }">
        <VChip
          v-if="item.status === 'Y'"
          color="success"
          variant="tonal"
          class="px-1"
          style="height: 30px; width: 30px;"
        >
          <VIcon icon="tabler-check" />
        </VChip>
        <VChip
          v-else
          color="error"
          variant="tonal"
          class="px-1"
          style="height: 30px; width: 30px;"
        >
          <VIcon icon="tabler-x" />
        </VChip>
      </template>
      <template #bottom>
        <TablePagination
          v-model:page="page"
          v-model:size="size"
          :items-per-page="size"
          :total-items="totalItems"
        />
      </template>
    </VDataTableServer>
  </VCard>

  <v-dialog v-if="dialog" v-model="dialog" max-width="600px" persistent :retain-focus="false">
    <v-card>
      <v-card-title>
        <span class="headline">{{ dialogTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="formDialog">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-autocomplete v-model="form.country"
                :items="allCountrys"
                item-title="country"
                item-value="countryCode"
                prepend-inner-icon="tabler-search"
                label="國家"
                @update:model-value="selectCountryActionDialog()"
                clearable
                ></v-autocomplete>
              </v-col>
              
              <v-col cols="12" sm="6">
                <v-autocomplete v-model="form.region"
                :items="allRegionsDialog" 
                no-data-text="尚無資料"
                item-title="region"
                item-value="regionCode"
                prepend-inner-icon="tabler-search"
                label="地區"
                :disabled="allRegionsDialog.length<1"
                clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <AmountTextField
                  v-model="form.amount"
                  :rules="[rules.required, rules.nonNegative]"
                  label="日支數額(美元)"
                  required
                />
              </v-col>
              <v-col cols="12" sm="6">
                <AppDateTimePicker
                  v-model="form.effectiveDate"
                  :rules="[rules.required]"
                  type="date"
                  label="生效時間"
                  label-inside
                />
              </v-col>
              <v-col cols="12" sm="6">
                <AppDateTimePicker
                  v-model="form.expiryDate"
                  type="date"
                  label="失效時間"
                  label-inside
                  :rules="[rules.required, rules.checkDate]"
                  ref="expiryPicker"
                  clearable
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="form.status"
                  :items="[{label: '啟用', value: 'Y'}, {label: '禁用', value: 'N'}]"
                  item-title="label"
                  item-value="value"
                  label="狀態"
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue-darken-1" variant="text" @click="closeDialog()">取消</v-btn>
        <v-btn color="blue-darken-1" variant="text" @click="save">確認</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script setup lang="ts">
import { computed, nextTick, onMounted, reactive, ref, watch } from "vue"
import { rocToWestern, westernToRoc } from "@/utils/dateChange"
definePage({
  meta: {
    action: 'manage', //固定為 manage
    subject: 'EXPENSEPERDIEM', //系統代碼(系統授權設定中的系統代碼)
  },
})
// 新增/修改
const dialogActionStatus=[
  {
    key:'新增',
    value:'add'
  },
  {
    key:'修改',
    value:'edit'
  },
]
interface PerDiemItem {
  prikey: string
  country: string
  countryName: string
  region: string
  regionName: string
  dailyAllowance: number
  effectiveDate: string
  expiryDate: string | null
  status: string
}

const dialogAction = ref(dialogActionStatus[0].value)
const formDialog = ref<any>(null)
const selectedCountry = ref<string | null>(null)
const selectedRegion = ref<string | null>(null)
const userData = reactive(JSON.parse(localStorage.getItem('userData') || '{}'));
const headers = reactive([
  { title: '', key: 'checkbox', sortable: false },
  { title: '國家', key: 'countryName' },
  { title: '地區', key: 'regionName' },
  { title: '日支數額(美元)', key: 'dailyAllowance' },
  { title: '生效日期', key: 'effectiveDate' },
  { title: '失效日期', key: 'expiryDate' },
  { title: '狀態', key: 'status' },
])
const tableSelected = ref<string[]>([])
const items = reactive<PerDiemItem[]>([])
const page = ref(1)
const size = ref(10)
const totalItems = ref(0)
const dialog = ref(false)
const dialogTitle = ref('')
const form = reactive({
  id: '',
  country: '',
  region: '',
  amount: '' as string | number,
  effectiveDate: '' as string | null,
  expiryDate: '' as string | null,
  status: 'Y',
})
const isInitializing = ref(false)
const fileInput = ref<HTMLInputElement | null>(null)

// 計算屬性：判斷選中的項目是否都是啟用狀態
const selectedItemsAreActive = computed(() => {
  if (tableSelected.value.length === 0) return true; // 預設為啟用狀態
  const selectedItems = items.filter((it: PerDiemItem) => tableSelected.value.includes(it.prikey));
  // 如果所有選中項目都是 'Y'，則顯示停用按鈕；否則顯示啟用按鈕
  return selectedItems.every(item => item.status === 'Y');
})

// 計算屬性：判斷當前使用者是否為 ICSC01
const isICSC01User = computed(() => {
  const uNo = userData?.userNo || userData?.userno;
  return uNo === 'ICSC01';
})

const menu = ref(false)
const expiryPicker = ref<any>(null)
const rules = ref({
  required: (value: any) => !!value || '此欄位為必填',
  nonNegative: (value: any) => {
    if (value === '' || value === null || value === undefined) return true
    return Number(String(value).replace(/,/g, '')) >= 0 || '日支數額不可為負數'
  },
  checkDate: (value: any) => {
    // 如果沒填，由 required 規則攔截，這裡回傳 true
    if (!value || !form.effectiveDate) return true;

    // 建議統一轉換為 Date 物件比較，避免字串格式造成的誤差
    const startDateStr = rocToWestern(form.effectiveDate, '/', '-')
    const endDateStr = rocToWestern(value, '/', '-')
    
    if (!startDateStr || !endDateStr) return true

    const start = new Date(startDateStr)
    const end = new Date(endDateStr)
    
    return end >= start || '失效時間不可早於生效時間'
  }
});

// 當生效日改變時，強迫失效日組件重新執行一次驗證規則
const validateExpiry = () => {
  if (form.expiryDate && expiryPicker.value && typeof expiryPicker.value.validate === 'function') {
    expiryPicker.value.validate();
  }
};

const checkExist = async () => {
  if (isInitializing.value || !form.country || !form.effectiveDate) return;
  try {
    const response = await $api('/tca/expensePerDiem/checkExist', {
      method: 'POST',
      body: {
        effectiveDate: rocToWestern(form.effectiveDate, '/', '-'),
        country: form.country,
        region: form.region,
        prikey: form.id
      },
    });
    if (response.isExist) {
      popSwal('warning', '提醒', '該生效日已存在資料');
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error checking existence:', error);
    return true;
  }
}

watch(() => form.effectiveDate, () => {
  validateExpiry();
  if (form.effectiveDate) {
    checkExist();
  }
});

const allRegions = reactive<any[]>([])
const allRegionsDialog = reactive<any[]>([])

const popSwal = (icon: any, title: any, text: any) => {
  if (icon == "success") {
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
        container: 'v-dialog-z-index',
      },
      buttonsStyling: false,
    });
  } else if (icon == "error") {
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      customClass: {
        confirmButton: 'btn btn-primary',
        container: 'v-dialog-z-index',
      },
      buttonsStyling: false,
    });
  } else {
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      customClass: {
        confirmButton: 'btn btn-primary',
        container: 'v-dialog-z-index',
      },
      buttonsStyling: false,
    });
  }
}

// API
// 查詢國家代碼select 
const { data: getAllCountrys, execute: getAllCountry } = await useApi<any>(createUrl('/tca/CountryAreaCode/getAllCountry'))
const allCountrys = computed(()=>{
  return getAllCountrys.value.map((item: any)=>{
    return {
      country:item[1],
      countryCode:item[0]
    }
  })
})

//查詢國家代碼select 
const getAllRegions = async (val: string | null) => {
  let countryCode = val ? val : ''
  try {
    const response = await $api('/tca/CountryAreaCode/getListByCountryCode', {
      method: 'POST',
      body: {
        countryCode,
      },
    });
    return response as any[]
  } catch (error) {
    console.error('Error during fetch:', error);
    return []
  }
}

//查詢國外出差生活日之數額資料 API
const fetchData =async(options?: { sortBy?: Array<{ key: string; order: string }> }) =>{
  let country = selectedCountry.value?selectedCountry.value:''
  let region = selectedRegion.value?selectedRegion.value:''
  
  // 處理排序參數
  let sortBy = ''
  let sortOrder = ''
  if (options && options.sortBy && options.sortBy.length > 0) {
    sortBy = options.sortBy[0].key
    sortOrder = options.sortBy[0].order === 'desc' ? 'desc' : 'asc'
  }
  
  try {
    const response = await $api('/tca/expensePerDiem/getList', {
      method: 'POST',
      body: {
        country,
        region,
        page:page.value-1,
        size:size.value,
        sortBy,
        sortOrder,
      },
    });
    items.splice(0 , items.length , ...response.content)
    totalItems.value = response.totalElements
  } catch (error) {
    items.splice(0 , items.length )
    totalItems.value = 0
    console.error('Error during fetch:', error);
  }
}

// 新增一筆國外出差生活日之書資料 API
const add = async (body: any) => {
  try {
    const response = await $api('/tca/expensePerDiem/add', {
      method: 'POST',
      body: body,
    });
    if (response.country) {
      selectedCountry.value = response.country;
      const regions = await getAllRegions(response.country);
      allRegions.splice(0, allRegions.length, ...regions);
      selectedRegion.value = response.region;
    }
    fetchData();
    dialog.value = false;
    popSwal("success", "新增成功", '');
    clearForm();

  } catch (error: any) {
    console.error('Error during fetch:', error);
    popSwal("error", "新增失敗", error.data || error.message || "請稍後再試");
  }
}
// 更新一筆國外出差生活日之書資料 API
const update = async (body: any, silent: boolean = false) => {
  try {
    const response = await $api('/tca/expensePerDiem/update', {
      method: 'POST',
      body: body,
    });
    if (response.country) {
      selectedCountry.value = response.country;
      const regions = await getAllRegions(response.country);
      allRegions.splice(0, allRegions.length, ...regions);
      selectedRegion.value = response.region;
    }
    fetchData();
    dialog.value = false;
    if (!silent) {
      popSwal("success", "編輯成功", '');
    }
    clearForm();
  } catch (error: any) {
    console.error('Error during fetch:', error);
    popSwal("error", "編輯失敗", error.data || error.message || "請稍後再試");
  }
}
// 刪除國外出差生活日之書資料 API
const deleteApi = async (body: any) => {
  try {
    await $api('/tca/expensePerDiem/delete', {
      method: 'POST',
      body: body,
    });
    fetchData();
    tableSelected.value = [];
  } catch (error: any) {
    console.error('Error during fetch:', error);
    popSwal('error', "刪除失敗", error.data || error.message || "請稍後再試");
  }
}



// method
const triggerImport = () => {
  fileInput.value?.click()
}

const handleImport = async (event: Event) => {
  const input = event.target as HTMLInputElement
  if (input.files && input.files.length > 0) {
    const file = input.files[0]
    await importExcelApi(file)
    // 清空 input 確保同個檔案可以重複選擇
    input.value = ''
  }
}

const importExcelApi = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)

  let timerInterval: any
  try {
    $swal({
      title: '正在匯入資料...',
      html: `
        <div class="mb-5" style="font-size: 1.1em; color: #555;">系統正在全力解析資料，請稍候...</div>
        <div style="width: 100%; background: #e2e8f0; border-radius: 100px; padding: 3px; box-shadow: inset 0 2px 4px rgba(0,0,0,0.1);">
          <div id="progress-bar" style="width: 0%; height: 16px; background: linear-gradient(90deg, #3b82f6, #8b5cf6); border-radius: 100px; transition: width 0.4s cubic-bezier(0.1, 1.2, 0.3, 1); position: relative; overflow: hidden;">
            <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-image: linear-gradient(45deg, rgba(255,255,255,0.2) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.2) 75%, transparent 75%, transparent); background-size: 40px 40px; animation: move-stripes 2s linear infinite;"></div>
          </div>
        </div>
        <div class="mt-4 d-flex justify-space-between align-center px-2">
          <span id="progress-text" style="font-size: 1.4em; font-weight: 900; background: linear-gradient(90deg, #3b82f6, #8b5cf6); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">0%</span>
          <span style="font-size: 0.9em; color: #94a3b8; font-style: italic; letter-spacing: 1px;">DATABASE UPDATING...</span>
        </div>
        <style>
          @keyframes move-stripes {
            from { background-position: 0 0; }
            to { background-position: 40px 0; }
          }
          .swal2-title {
            font-size: 1.8em !important;
            font-weight: 800 !important;
            color: #1e293b !important;
          }
        </style>
      `,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: (popup) => {
        const bar = popup.querySelector('#progress-bar') as HTMLElement
        const text = popup.querySelector('#progress-text') as HTMLElement
        let progress = 0
        timerInterval = setInterval(() => {
          if (progress < 95) {
            progress += Math.random() * 5
            if (progress > 95) progress = 95
            if (bar) bar.style.width = `${progress}%`
            if (text) text.textContent = `${Math.round(progress)}%`
          }
        }, 400)
      },
      willClose: () => {
        clearInterval(timerInterval)
      },
      customClass: {
        container: 'v-dialog-z-index',
      },
    })

    const response = await $api('/tca/expensePerDiem/importExcel', {
      method: 'POST',
      body: formData,
    })

    let htmlContent = `<div style="text-align: left; white-space: pre-wrap;">成功匯入 ${response.successCount} 筆新資料。</div>`
    if (response.updatedCount > 0) {
      htmlContent += `<div style="text-align: left; white-space: pre-wrap;">自動更新 ${response.updatedCount} 筆既有資料。</div>`
    }
    if (response.errorLog) {
      htmlContent += `<div style="text-align: left; white-space: pre-wrap; margin-top: 15px; color: #ff9800; font-weight: bold;">發生以下錯誤：</div>`
      htmlContent += `<div style="text-align: left; white-space: pre-wrap; margin-top: 5px; font-size: 0.9em; max-height: 300px; overflow-y: auto;">${response.errorLog}</div>`
    }
    $swal({
      icon: response.errorLog ? 'warning' : 'success',
      title: '匯入結果',
      html: htmlContent,
      confirmButtonText: '確定',
      customClass: {
        confirmButton: 'btn btn-primary',
        container: 'v-dialog-z-index',
      },
      buttonsStyling: false,
    })

    fetchData()
  } catch (error: any) {
    console.error('Import error:', error)
    const errorMsg = error.data || error.message || '請檢查 Excel 格式是否正確。'
    $swal({
      icon: 'error',
      title: '匯入失敗',
      html: `<div style="text-align: left; white-space: pre-wrap;">${errorMsg}</div>`,
      confirmButtonText: '確定',
      customClass: {
        confirmButton: 'btn btn-primary',
        container: 'v-dialog-z-index',
      },
      buttonsStyling: false,
    })
  }
}

const downloadSample = async () => {
  try {
    const response = await $api('/tca/expensePerDiem/downloadSample', {
      method: 'GET',
      responseType: 'blob',
    })

    const blob = new Blob([response as any], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', '國外出差日支數額匯入範本.xlsx')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Download error:', error)
    popSwal('error', '下載失敗', '系統忙碌中，請稍後再試。')
  }
}

const openDialog = async(type: string) => {
  const isEdit = type === dialogActionStatus[1].value
  dialogTitle.value = isEdit ? '修改國外出差日支數額' : '新增國外出差日支數額';
  dialogAction.value = type

  if (isEdit) {
    const selectedId = tableSelected.value[0]
    const editItem = items.find(item => item.prikey == selectedId)
    if (editItem) {
      await setFormData(editItem)
      dialog.value = true
    } else {
      popSwal('warning', '提醒', '找不到選中的資料，請重新選取')
    }
  } else {
    form.id = ''
    form.country = ''
    form.region = ''
    form.amount = 0
    form.effectiveDate = ''
    form.expiryDate = ''
    form.status = 'Y'
    dialog.value = true
  }
}
const setFormData = async(data: any) =>{
  isInitializing.value = true
  console.log(data)
  let regions = await getAllRegions(data.country)
  allRegionsDialog.splice(0 , allRegionsDialog.length , ...regions)
  form.id=data.prikey
  form.country = data.country
  form.region= data.region
  console.log(form.region)
  form.amount= data.dailyAllowance
  form.effectiveDate= westernToRoc(data.effectiveDate,'-','/')
  form.expiryDate = westernToRoc(data.expiryDate, '-', '/')
  form.status = data.status || 'Y'
  
  // 使用 nextTick 確保 watch 觸發完畢後再解除鎖定
  nextTick(() => {
    isInitializing.value = false
  })
}

const editBtn = (type: string) => {
  openDialog(type)
}
const closeDialog = () => {
  dialog.value = false
}

// v-form 驗證
const submitForm=async() => {
  const { valid } = await formDialog.value.validate();
  return valid
}

const clearForm = () =>{
  formDialog.value?.reset();
  form.effectiveDate =''
  form.expiryDate = ''
  form.status = 'Y'
}

const dialogData = async () => {
  let data = {
    effectiveDate: rocToWestern(form.effectiveDate || '', '/', '-'),
    country: form.country,
    expiryDate: rocToWestern(form.expiryDate || '', '/', '-'),
    region: form.region,
    dailyAllowance: Number(form.amount),
    prikey: form.id,
    status: form.status,
  }
  return data
}

const save = async() => {
  const valid = await submitForm();
  // 儲存邏輯
  if(valid){
    dialog.value = false
    const data =await dialogData()
    console.log(data)
    if(dialogAction.value==dialogActionStatus[0].value){
      data.prikey=""
      add(data)
    }else{
      console.log('edit save')
      update(data)
    }
  }
}
const deleteBtn = async () => {
  $swal({
    title: `刪除資料`,
    text: "",
    showCancelButton: true,
    confirmButtonText: "我要刪除",
    cancelButtonText: "取消",
  }).then(async (result: any) => {
    if (result.isConfirmed) {
      const data = items.filter((it: PerDiemItem) => tableSelected.value.includes(it.prikey));
      await deleteApi(data)
    }
  })
}

const toggleStatusBtn = async () => {
  const selectedItems = items.filter((it: PerDiemItem) => tableSelected.value.includes(it.prikey));
  const isEnabling = !selectedItemsAreActive.value; // 如果當前不是全部啟用，則執行啟用操作
  const newStatus = isEnabling ? 'Y' : 'N';
  const actionText = isEnabling ? '啟用' : '停用';
  
  $swal({
    title: `${actionText}資料`,
    text: `確定要${actionText}選中的日支數紀錄嗎？`,
    showCancelButton: true,
    confirmButtonText: `確定${actionText}`,
    cancelButtonText: "取消",
  }).then(async (result: any) => {
    if (result.isConfirmed) {
      // 批次更新每個選中項目的狀態（靜默模式，不顯示個別成功訊息）
      for (const item of selectedItems) {
        const data = {
          prikey: item.prikey,
          country: item.country,
          region: item.region,
          dailyAllowance: item.dailyAllowance,
          effectiveDate: item.effectiveDate,
          expiryDate: item.expiryDate,
          status: newStatus
        };
        await update(data, true); // 傳入 silent: true 參數
      }
      
      // 清空選擇並重新載入資料
      tableSelected.value = [];
      await fetchData({});
      popSwal('success', '成功', `已成功${actionText}選中的紀錄`);
    }
  })
}

const selectCountryAction = async () => {
  selectedRegion.value = null
  allRegions.splice(0, allRegions.length)
  console.log(allRegions)
  if (selectedCountry.value) {
    let data = await getAllRegions(selectedCountry.value)
    allRegions.splice(0, allRegions.length, ...data)
  }
}
const selectCountryActionDialog = async () => {
  form.region = ''
  allRegionsDialog.splice(0, allRegionsDialog.length)
  console.log(allRegionsDialog)
  if (form.country) {
    let data = await getAllRegions(form.country)
    allRegionsDialog.splice(0, allRegionsDialog.length, ...data)
  }
}

// watch(()=>form.country,async()=>{
//   const res = await getAllRegions(form.country)
  
//   allRegionsDialog.splice(0 , allRegionsDialog.length , ...res)
// })

watch(selectedCountry,async()=>{
  fetchData()
})

watch(selectedRegion,async()=>{
  fetchData()
})

watch(size,()=>{
  fetchData()
})
watch(page,()=>{
  fetchData()
})

onMounted(async () => {
  const res = await getAllRegions(null)
  fetchData()
  allRegions.splice(0, allRegions.length, ...res)
  allRegionsDialog.splice(0, allRegionsDialog.length, ...res)
})
</script>

<style scoped>
.headline {
  font-weight: bold;
}
</style>

<style>
.v-dialog-z-index {
  z-index: 3000 !important;
}
</style>
